import { render, staticRenderFns } from "./table-monthly-goal-registration.page.vue?vue&type=template&id=a1dce5d2"
import script from "./table-monthly-goal-registration.page.vue?vue&type=script&lang=ts"
export * from "./table-monthly-goal-registration.page.vue?vue&type=script&lang=ts"
import style0 from "./table-monthly-goal-registration.page.vue?vue&type=style&index=0&id=a1dce5d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports